import { takeEvery, all, call, put } from 'redux-saga/effects'

import * as argus from 'api/argus'
import { FETCH_CLIENT_CONFIG_REQUEST } from 'containers/app/constants'
import {
  authenticateFailure,
  fetchClientConfigSuccess,
  fetchClientConfigFailure,
} from 'containers/app/actions'

function* fetchClientConfig() {
  try {
    const config = yield call(argus.fetchPublicData, '/public/config')
    yield put(fetchClientConfigSuccess(config))
  } catch ({ error, response }) {
    yield put(fetchClientConfigFailure(error.message))
    if (response && response.status === 401) {
      yield put(authenticateFailure())
    }
  }
}

function* watchClientConfig() {
  yield takeEvery(FETCH_CLIENT_CONFIG_REQUEST, fetchClientConfig)
}

function* clientConfigSagas() {
  yield all([watchClientConfig()])
}

export default clientConfigSagas
